import { useInstance } from 'intact-vue-next';
export function useFormatter() {
  var instance = useInstance();
  function format(value) {
    var _instance$get = instance.get(),
      formatter = _instance$get.formatter,
      prefix = _instance$get.prefix,
      suffix = _instance$get.suffix;
    if (!formatter) {
      return "" + (prefix || '') + value + (suffix || '');
    }
    return formatter(value);
  }
  function parse(value) {
    var _instance$get2 = instance.get(),
      parser = _instance$get2.parser,
      prefix = _instance$get2.prefix,
      suffix = _instance$get2.suffix;
    if (value === '') {
      return NaN;
    }
    if (!parser) {
      if (prefix) {
        value = value.replace(new RegExp("^" + prefix), '');
      }
      if (suffix) {
        value = value.replace(new RegExp(suffix + "$"), '');
      }
      return +value;
    }
    return parser(value);
  }
  return {
    format: format,
    parse: parse
  };
}